import styled from "styled-components/macro";
import { get } from "lodash";

export const CardsContainer = styled.div`
    ${({ theme }) => theme.bp.xs`
        padding: 0px 0px;
    `};
    ${({ theme }) => theme.bp.sm`
        padding: 0px 0vw;
        width: 30%;
        align-items: flex-end;
    `};
    padding: 20px 3vw;
    margin-bottom: 10px;
`;

export const Card = styled.div`
    ${({ theme }) => theme.bp.xs`
        padding: 20px;
        margin: 1vh 0px;
        width: auto;
    `};
    ${({ theme }) => theme.bp.sm`
        padding: 10px;
        margin: 5px 20px;
        width: 80%;
    `};
    ${({ theme }) => theme.bp.xxl`
        padding: 10px 30px;
        margin: 5px 20px;
        width: 380px;
    `};
    border-radius: 4px;
    width: 410px;
    background: white;
    box-shadow: ${({ theme }) => (get(theme, "summary.card.shadow") ? "0px 2px 4px 0px rgba(0, 0, 0, 0.2);" : "none;")};
    border: 1px solid #d9d9d9;
    display: flex;
    flex-flow: column;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    position: relative;
    flex: 1 1 auto;
`;
export const CardTitle = styled.div`
    ${({ theme }) => theme.bp.xs`
        font-size: 18px;
    `};
    ${({ theme }) => theme.bp.xl`
        font-size: 20px;
    `};
    ${({ theme }) => theme.bp.xxl`
        font-size: 24px;
    `};
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1.4em;
                `}
    color: ${props => props.theme.textColor};
    font-family: ${props => props.theme.fontFamily};
`;
export const CardDescription = styled.div`
    ${({ theme }) => theme.bp.xs`
        font-size: 13px;
    `};
    ${({ theme }) => theme.bp.sm`
        font-size: 12px;
    `};
    ${({ theme }) => theme.bp.xl`
        font-size: 13px;
    `};
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1.1em;
                `}
    line-height: ${({ theme }) => get(theme, "summary.card.lineHeight") || 1};
    padding: 15px 0px;
    font-size: 14px;
    color: ${props => props.theme.textColor};
    font-family: ${props => props.theme.fontFamily};
    font-weight: 200;
    width: 100%;
`;

interface CardButtonProps {
    isDisabled?: Boolean;
}

export const CardButton = styled.div<CardButtonProps>`
    ${({ theme }) => theme.bp.xs`
        font-size: 13px;
        height: 40px;
    `};
    ${({ theme }) => theme.bp.xl`
        font-size: 14px;
    `};
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1.1em;
                `}

    margin: 15px 0px;
    background: ${props => (props.isDisabled ? "#b9b9b9" : get(props.theme, "summary.card.button.backgroundColor"))};
    color: ${props => (props.isDisabled ? "#626262" : "#ffffff")};
    cursor: pointer;
    width: 100%;
    font-family: ${props => props.theme.fontFamily};
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 0.2s ease-in-out;
    box-shadow: ${({ theme }) =>
        get(theme, "summary.card.button.shadow") ? "0px 2px 4px 1px rgba(0, 0, 0, 0.2);" : "none"};

    @media (hover) {
        &:hover {
            background: ${props => (props.isDisabled ? "#b9b9b9" : get(props.theme, "summary.card.button.hoverColor"))};
        }
        &:active {
            background: ${props =>
                props.isDisabled ? "#b9b9b9" : get(props.theme, "summary.card.button.activeColor")};
        }
    }
`;

export const SecondaryCardButton = styled.div<CardButtonProps>`
    ${({ theme }) => theme.bp.xs`
        font-size: 13px;
        height: 36px;
    `};
    ${({ theme }) => theme.bp.xl`
        font-size: 14px;
    `};
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1.1em;
                `}

    margin: 15px 0px;
    background: ${props => (props.isDisabled ? "#b9b9b9" : "white")};
    color: ${props => (props.isDisabled ? "#626262" : "black")};
    cursor: pointer;
    border: solid 2px var(--primary-color);
    width: 100%;
    font-family: ${props => props.theme.fontFamily};
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 0.2s ease-in-out;
    box-shadow: ${({ theme }) =>
        get(theme, "summary.card.button.shadow") ? "0px 2px 4px 1px rgba(0, 0, 0, 0.2);" : "none"};

    @media (hover) {
        &:hover {
            background: ${props => (props.isDisabled ? "#b9b9b9" : "var(--light-hover-color)")};
        }
        &:active {
            background: ${props => (props.isDisabled ? "#b9b9b9" : "var(--light-active-color)")};
        }
    }
`;

export const CardButtonText = styled.p`
    padding: 0px 10px;
`;
